/**
 * Experiment constants and EXPERIMENT_REGISTRY.
 * Constant format: {ticket}_-_{description}, e.g. pd-10103_-_… or skale-0014_-_….
 *
 * See docs/experiments.md for when to register in EXPERIMENT_REGISTRY,
 * exposure semantics, and the full add/remove workflow.
 */

/** Lowercase id prefixes per experiment source; consumers build their regexes from this. */
export const EXPERIMENT_ID_PREFIXES = ['pd', 'skale']

export const PD_10103_REMOVE_DORMER_QUESTIONS =
  'pd-10103_-_remove_unnecessary_dormer_questions'

export const PD_10118_REMOVE_PAINTING_QUESTIONS =
  'pd-10118_-_remove_unnecessary_painting_questions'

export const PD_10636_GRADIENT_HERO_BACKGROUND =
  'pd-10636_-_gradient_hero_background'

export const PD_10639_ADD_INTRO_STEP = 'pd-10639_-_add_intro_step'

export const SKALE_0014_REDESIGNED_FUNNEL =
  'skale-0014_-_complete_redesigned_funnel_-_makelaarwijzer-nl'

export const SKALE_0018_KOZIJNEN_QUESTIONS_IN_FLOW =
  'skale-0018_-_kozijnvergelijker_questions_implemented_in_flow_-_ramenvergelijker-be'

export const SKALE_0020_GEO_PLACES_AUTOFILL =
  'skale-0020_-_geo_places_api_autofill_form_fields_-_comparateurdagences'

export const EXPERIMENT_REGISTRY = {
  'dakkapellenvergelijker.nl': [PD_10103_REMOVE_DORMER_QUESTIONS],
  'schildervergelijker.nl': [PD_10118_REMOVE_PAINTING_QUESTIONS],
  'immokantoorvergelijker.be': [PD_10636_GRADIENT_HERO_BACKGROUND],
  'kozijnenvergelijker.nl': [PD_10639_ADD_INTRO_STEP],
  'ramenvergelijker.be': [SKALE_0018_KOZIJNEN_QUESTIONS_IN_FLOW],
  'comparateurdagencesimmobilieres.be': [SKALE_0020_GEO_PLACES_AUTOFILL],
}

/**
 * Get experiment IDs registered for a specific concept.
 * @param {string} conceptId - The concept domain (e.g. 'makelaarwijzer.nl')
 * @returns {string[]}
 */
export function getRegisteredExperimentIds(conceptId) {
  return EXPERIMENT_REGISTRY[conceptId] || []
}
